import useIsClient from "@/hooks/useIsClient";
import "@/assets/scss/lightgallery.css";
import {
  LightgalleryItem,
  LightgalleryProvider,
  useLightgallery,
} from "react-lightgallery";

const PhotoItem = ({ image, thumb, group }: any) => (
  <LightgalleryItem group={group} src={image} thumb={thumb}></LightgalleryItem>
);

const PreviewProvider: React.FC<{
  images: string[];
  children: PreviewChildrenType;
}> = ({ images, children }) => {
  const isClient = useIsClient();
  if (!isClient) return;
  return (
    <LightgalleryProvider
      portalElementSelector=".gallery-portal"
      onBeforeOpen={() => console.info("onBeforeOpen")}
      onAfterOpen={() => console.info("onAfterOpen")}
      onSlideItemLoad={() => console.info("onSlideItemLoad")}
      onBeforeSlide={() => console.info("onBeforeSlide")}
      onAfterSlide={() => console.info("onAfterSlide")}
      onBeforePrevSlide={() => console.info("onBeforePrevSlide")}
      onBeforeNextSlide={() => console.info("onBeforeNextSlide")}
      onDragstart={() => console.info("onDragstart")}
      onDragmove={() => console.info("onDragmove")}
      onDragend={() => console.info("onDragend")}
      onSlideClick={() => console.info("onSlideClick")}
      onBeforeClose={() => console.info("onBeforeClose")}
      onCloseAfter={() => console.info("onCloseAfter")}
    >
      {images.map((p, idx) => (
        <PhotoItem key={idx} image={p} group="group" />
      ))}
      <PreviewContent>{children}</PreviewContent>
    </LightgalleryProvider>
  );
};

export default PreviewProvider;

const PreviewContent = ({ children }: { children: PreviewChildrenType }) => {
  const { openGallery: hookOpenGallery } = useLightgallery();
  const openGallery = (index?: number) => {
    hookOpenGallery("group", index);
  };
  return children(openGallery);
};

type PreviewChildrenType = (
  openGallery: (index?: number) => void,
) => React.ReactNode;
